import { InjectionToken } from '@angular/core';

/**
 * Whether the brand prices labour separately from parts. Federated systems that carry every sale line as a
 * part set this false so labour columns and filters, which could only ever be empty, are not rendered.
 */
export const LABOR_ENABLED = new InjectionToken<boolean>('LABOR_ENABLED', {
    providedIn: 'root',
    factory: () => true,
});
